import { useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { t } from "@/lib/translations";
import { resolveImg } from "@/lib/api";
import { Reveal } from "./Reveal";
import { Lightbox } from "./Lightbox";
import { Maximize2 } from "lucide-react";

export const Gallery = ({ items }) => {
  const { lang } = useLang();
  const [lb, setLb] = useState(null);
  return (
    <section id="gallery" className="relative z-10 bg-[#0A0A0A] py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <span className="text-xs tracking-[0.25em] uppercase font-bold text-[#FF5A00]">{t("gallery_kicker", lang)}</span>
          <h2 className="font-display uppercase text-5xl md:text-7xl mt-3 leading-none">{t("gallery_title", lang)}</h2>
        </Reveal>

        <div className="mt-12 columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {items.map((g, i) => (
            <motion.div
              key={g.id}
              data-testid={`gallery-item-${g.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className="group relative mb-5 break-inside-avoid overflow-hidden rounded-2xl border border-white/5 cursor-zoom-in"
              onClick={() => setLb({ src: resolveImg(g.image), caption: lang === "es" ? g.caption_es : g.caption_en })}
            >
              <img
                src={resolveImg(g.image)}
                alt={lang === "es" ? g.caption_es : g.caption_en}
                className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute top-3 right-3 h-9 w-9 rounded-full bg-black/50 backdrop-blur flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
                <Maximize2 size={16} />
              </span>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent flex items-end p-5 pt-16 pointer-events-none">
                <span className="font-accent text-2xl text-[#A8E010] drop-shadow-lg">{lang === "es" ? g.caption_es : g.caption_en}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <Lightbox open={!!lb} src={lb?.src} caption={lb?.caption} onClose={() => setLb(null)} />
    </section>
  );
};
